<template>
  <div class="page-main">
    <Panel :padding="0">
      <div class="intro_top">
        <img src="@/assets/images/hsk_eg.png" alt="" />
        <div class="intro_top-title">{{ filterPaperName(titleTrans) }}</div>
      </div>
      <div class="intro_table">
        <Level7Table
          :tableData="tableData"
          :setSellStyle="setSellStyle"
          v-if="level == 'hsk7'"
        ></Level7Table>
        <HskkTable
          :tableData="tableData"
          :setSellStyle="setSellStyle"
          v-else-if="level == 'hskk1' || level == 'hskk2' || level == 'hskk3'"
        ></HskkTable>
        <el-table
          v-else
          :data="tableData"
          :span-method="objectSpanMethod"
          :header-cell-style="discountHeaderStyle"
          :cell-style="setSellStyle"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            :label="$t('hsk_test_content')"
            width="180"
            header-align="center"
            align="center"
          >
            <el-table-column prop="segmentCode" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="segment-cell">
                  <img
                    class="segment_img"
                    :class="{ segment_img_listen: scope.row.segmentCodePart === 'listen' }"
                    :src="require(`@/assets/images/hsk/${scope.row.segmentCodePart}.png`)"
                    alt=""
                  />
                  <span class="segment-cell-text">{{ scope.row.segmentCode }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="partCode" header-align="center" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('hsk_test_num')" header-align="center" align="center">
            <el-table-column prop="questionCount" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="questionCountMoudleTotal" header-align="center" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="totalQuestionCount"
            :label="$t('hsk_total_num')"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="duration"
            :label="$t('hsk_test_time')"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="segment-cell">
                <img class="segment_img" :src="require(`@/assets/images/hsk/time1.png`)" alt="" />
                <span class="segment-cell-text">{{ scope.row.duration }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalDuration"
            :label="$t('hsk_time_total')"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="segment-cell">
                <img class="segment_img" :src="require(`@/assets/images/hsk/time1.png`)" alt="" />
                <span class="segment-cell-text">{{ scope.row.totalDuration }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="intro-msg">
          <ol>
            <li>{{ introMsgFirst }}</li>
            <li>{{ $t('intro_msg_second') }}</li>
            <li>{{ $t('intro_msg_third') }}</li>
          </ol>
        </div>
      </div>
      <div v-if="paperStatus == 0">
        <div class="btn-tips">{{ $t('hsk_if_test') }}</div>
        <Toolbar justifyContent="center">
          <button
            class="btn-extend"
            :class="{ disabled: isDisabled }"
            @click="startExam(2)"
            v-if="$route.query.examinationType !== 4"
          >
            {{ $t('hsk_start_again') }}
          </button>
          <button
            class="btn-yellow btn-extend"
            :class="{ disabled: isDisabled }"
            @click="confirm(1)"
          >
            {{ $t('hsk_go_on') }}
          </button>
        </Toolbar>
      </div>

      <Toolbar justifyContent="center" v-else>
        <button
          class="btn-yellow btn-submit"
          :class="{ disabled: isDisabled }"
          @click="startExam(0)"
        >
          {{ $t('hsk_start_exam') }}
        </button>
      </Toolbar>
    </Panel>
    <!-- 弹框进行试音 -->
    <el-dialog
      :title="level == 'hskk1' || level == 'hskk2' || level == 'hskk3' ? this.$t('hskk_listen_name') : this.$t('hsk_listen_name')"
      :visible.sync="dialogReadyVisible"
      top="15vh"
      width="940px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="hsk_skip"
    >
      <TestRadio
        :listenReviewDuration="listenReviewDuration"
        :showConcatUs="true"
        :testmp3="testmp3"
        :isDisabled="isDisabled"
        :functionType="'speaker'"
        :fromPage="'introduce'"
        :level="level"
        @skip="skip"
        @contactUs="contactUs"
      >
      </TestRadio>
    </el-dialog>
    <!-- 支付确认弹框 -->
    <!-- <el-dialog title="" :visible.sync="dialogPayVisible" top="30vh" width="390px" center>
      <div class="pay-title">
        {{ filterPaperName(titleTrans) }}
      </div>
      <div class="diamond">
        <div class="key_desc">{{ $t("hsk_cost") }}：</div>
        <SvgIcon type="diamond" class="icon-18"></SvgIcon>
        <div class="numbers">&nbsp;{{ needCredit }}</div>
      </div>
      <div class="balance">
        <div class="key_desc">{{ $t("hsk_credit") }}：</div>
        <SvgIcon type="diamond" class="icon-18"></SvgIcon>
        <div :style="{ color: enough ? '#39B38E' : '#FC5A5A' }">&nbsp;{{ paperCredit }}</div>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="$t('hsk_select_amount')" name="1">
          <MuiRecharge @order="getOrderId" :difference="paperCredit - needCredit" v-if="dialogPayVisible">
            <button class="btn-yellow btn-exam" @click="confirm(0)" :disabled="!enough" slot="btn">
              {{ $t("hsk_spend") }} <SvgIcon type="diamond" class="icon-18 m-l-8 m-r-10"></SvgIcon> {{ needCredit }}
            </button>
          </MuiRecharge>
        </el-collapse-item>
      </el-collapse>
      <button class="btn-yellow btn-exam-out" @click="confirm(0)" :disabled="!enough" v-if="activeNames[0] != 1">
        {{ $t("hsk_spend") }} <SvgIcon type="diamond" class="icon-18 m-l-8 m-r-10"></SvgIcon> {{ needCredit }}
      </button>
    </el-dialog> -->
    <!-- 支付回调弹框 -->
    <el-dialog
      :visible.sync="dialogPayCb"
      top="30vh"
      width="432px"
      center
      custom-class="pay-body"
      @close="closePay"
    >
      <!-- <div v-if="isPaySuccess" class="pay-success">
        <div class="success-bg">
          <SvgIcon type="pay-success" class="icon-48"></SvgIcon>
        </div>
        <div class="m-t-10">{{ $t("hsk_pay_successfully") }}</div>
      </div> -->
      <div class="pay-loading">
        <img src="@/assets/images/loading.png" alt="" width="60" height="60" />
        <div class="pay-tips">{{ $t('waiting_pay') }}</div>
      </div>
      <div class="un_pay_tips">
        <div class="flex">
          {{ $t('pay_failed') }}
          <p @click="linkPay()">{{ $t('common_text_server_error') }}</p>
        </div>
        <div class="flex m-t-10">
          {{ $t('pay_un_finished') }}
          <p class="contact-us" @click="contactUs()">{{ $t('feedback') }}</p>
        </div>
      </div>
      <!-- <div class="button-tools">
        <button class="btn-default btm-pay" @click="payCancel()">{{ $t("button_common_cancel") }}</button>
        <button class="btn-yellow btm-pay" @click="payFinished()">{{ $t("complete_pay") }}</button>
      </div> -->
    </el-dialog>
    <el-dialog :visible.sync="dialogPayCheck" top="30vh" width="940px" @close="closePayCheck">
      <div slot="title" class="pay-header">{{ $t('choose_method') }}</div>
      <p class="pay-text">{{ $t('choose_new_method') }}</p>
      <div class="flex flex-center">
        <mui-button class="use-code" @click="useCode">{{ $t('use_code') }}</mui-button>
        <mui-button
          type="yellow"
          class="use-buy"
          @click="checkPay"
          v-if="!$store.state.user.isCodeUser"
          >{{ $t('hsk_buy') }}</mui-button
        >
      </div>
    </el-dialog>
    <!-- 试卷介绍弹窗 -->
    <el-dialog
      :title="$t('dialogue_mock_paper_intro_title')"
      top="30vh"
      width="940px"
      :visible.sync="paperIntroDialogueShow"
      center
      custom-class="paper-intro"
    >
      <div class="paper-intro-wrap">
        <ol>
          <li v-for="item in paperIntroData" :key="item.id">
            <img :src="item.logo" alt="" />
            <span class="paper-intro-text" style="word-break: break-word">{{ item.text }}</span>
          </li>
        </ol>
        <button class="btn-yellow close-btn" @click="paperIntroDialogueShow = false">
          {{ $t('dialogue_mock_paper_intro_button') }}
        </button>
        <p class="questions-wrap">
          {{ $t('dialogue_intro_question') }}
          <b class="contact-us" @click="contactUs()">{{ $t('feedback') }}</b>
        </p>
      </div>
    </el-dialog>
    <use-code ref="useCode" :nameTrans="titleTrans" @onOk="onOk"></use-code>
  </div>
</template>

<script>
import { numberToChinese, transferLanguage } from '@/utils/utils.js'
import { Dialog, Dropdown, Table, TableColumn } from 'element-ui'
// import SvgIcon from "@/components/SvgIcon.vue";
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import { mapState } from 'vuex'
import { apiRequest } from '@/serves/http'
import { IS_CHINA } from '@/config'
import Preload from '@/components/ui/preload'
import UseCode from '@/components/useCode/index.vue'
import TestRadio from '@/components/hsk/common/testRadio.vue'
import Level7Table from './introduce/7-9table.vue'
import HskkTable from './introduce/hskkTable.vue'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    UseCode,
    TestRadio,
    Level7Table,
    HskkTable,
    // SvgIcon,
  },
  mixins: [mixinMixpanel],
  data() {
    return {
      tableData: [],
      isDisabled: false,
      dialogReadyVisible: false,
      // 试音音频
      testmp3: '',
      // 听力预览音频
      explainAudio: '',
      randomIntervalObj: null,
      titleTrans: '',
      //用于计算table合并行
      segments: [],
      // 当前重新还是继续 0 重新考试  1 继续考试
      ansStatus: 0,
      paperStatus: this.$route.query.paperStatus,
      // 支付弹框
      // dialogPayVisible: false,
      // 充值弹框
      // dialogRecharge: false,
      // 当前试卷需要几个credit
      needCredit: 0,
      // 当前用户剩余多少credit
      paperCredit: 0,
      // 当前用户余额是否足够
      // enough: false,
      // 商品列表
      rechargeList: [],
      // 支付回调弹框
      dialogPayCb: false,
      // 订单ID
      orderId: '',
      //支付钻石数量
      payNum: '',
      // activeNames: [],
      // dragValue: ["1"],
      searchResultObj: null,
      isPaySuccess: false,
      //试卷类型
      levelName: '',
      rootPath: '',
      queue: null,
      isLoad: false,
      dialogPayCheck: false,
      productId: null,
      // 等级介绍第一段
      introMsgFirst: '',
      // 试卷介绍弹窗是否展示
      paperIntroDialogueShow: true,
      // 试卷介绍弹窗数据
      // paperIntroData: ,
      // 试卷等级
      level: this.$route.query.level,
      levelId: '',
      // 听力预览时间
      listenReviewDuration: 0,
      paperLevelId: '',
    }
  },
  created() {
    const levelArr = ['hsk1', 'hsk2', 'yct1', 'yct2', 'yct3']
    let num = 3
    if (levelArr.includes(this.level)) {
      num = 2
    }
    if (this.level == 'hsk7') {
      num = 5
    }
    if (this.level == 'hskk1' || this.level == 'hskk2' || this.level == 'hskk3') {
      num = 3
    }
    this.introMsgFirst = this.$t('intro_msg_first', {
      num: num,
    })
  },
  mounted() {
    this.getPaperDetails()
    this.getLevelId()
    console.log(this.levelId, 'get levelId')
    // if (this.isFree) return;
    // this.searchAccountCredit(true).then(() => {
    //   if (this.paperStatus !== 0) {
    //     this.dialogPayVisible = true;
    //   }
    // });
    // console.log(returnCitySN["cip"], returnCitySN["cname"]);
  },
  computed: {
    ...mapState({
      isFree: (state) => state.user.isFree,
      levelTypeList: (state) => state.level.levelList,
    }),
    paperIntroData() {
      let originalData = [
        {
          logo: require('@/assets/images/hsk/intro/clock.svg'),
          text: this.$t('dialogue_mock_paper_intro_sentence1', {
            minutes:
              (this.tableData[0] && (this.tableData[0]?.totalDuration?.match(/\d+/))[0]) || 80,
          }),
        },
        {
          logo: require('@/assets/images/hsk/intro/global.svg'),
          text: this.$t('dialogue_mock_paper_intro_sentence2'),
        },
        {
          logo: require('@/assets/images/hsk/intro/internet.svg'),
          text: this.$t('dialogue_mock_paper_intro_sentence3'),
        },
        {
          logo: require('@/assets/images/hsk/intro/phone.svg'),
          text: this.$t('dialogue_mock_paper_intro_sentence4'),
        },
        {
          logo: require('@/assets/images/hsk/intro/person.svg'),
          text: this.$t('dialogue_mock_paper_intro_sentence5'),
        },
      ]
      if (this.$route.query.level == 'hsk7') {
        // hsk 7-9 隐藏第四条
        originalData.splice(3, 1)
      }

      return originalData
    },
  },
  watch: {
    dialogPayCb: {
      handler(val) {
        if (!val) {
          this.searchResultObj && clearInterval(this.searchResultObj)
        }
      },
    },
    levelTypeList: {
      handler(val) {
        console.log(val)
        this.getLevelId()
      },
      deep: true,
    },
  },
  methods: {
    getLevelId() {
      if (!this.$route.query.level) return
      let res = ''
      if (this.levelTypeList.length > 0) {
        this.levelTypeList.forEach((item) => {
          console.log(item, 'level item <<<<<<<<<<<<')
          res = item.levels.find((level) => {
            let name = item?.type_name + level.level_id
            if (name) {
              name = name.toLowerCase()
            }
            return name === this.$route.query.level
          })
          if (res) {
            this.levelId = res.id
            console.log('res', res)
          }
        })
      }
    },
    setSellStyle({ row }) {
      if (row.segmentCodePart === 'listen') {
        return 'background:rgba(55, 169, 231, 0.1);border-radius: 8px;border:none;'
      }
      if (row.segmentCodePart === 'read') {
        return 'background:rgba(99, 196, 168, 0.09);border-radius: 8px;border:none;'
      }
      if (row.segmentCodePart === 'write') {
        return 'background:rgba(55, 169, 231, 0.1);border-radius: 8px;border:none;'
      }
      if (row.segmentCodePart === 'translation') {
        return 'background:rgba(99, 196, 168, 0.09);border-radius: 8px;border:none;'
      }
      if (row.segmentCodePart === 'speaking') {
        return 'background:rgba(55, 169, 231, 0.1);border-radius: 8px;border:none;'
      }
    },
    closePayCheck() {
      this.dialogPayCheck = false
    },
    useCode() {
      this.closePayCheck()
      this.openCodeDialog()
    },
    openCodeDialog() {
      let mixpanelParams = {
        paper_type: this.filterPaperName(this.titleTrans),
        exam_type: this.levelName,
        type: 'useCode',
      }
      analytics.logEvent('hskweb_restartconfirm_click', mixpanelParams)
      this.$refs.useCode?.openDialog(this.$route.query.paperId, this.levelId)
    },
    onOk() {
      this.confirm(0)
    },
    // 合并行
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3 || columnIndex === 5) {
        const arr = this.getSpan(this.tableData)
        const row = arr[rowIndex].row
        const col = arr[rowIndex].col
        return {
          rowspan: row,
          colspan: col,
        }
      } else if (columnIndex === 4 || columnIndex === 6) {
        let sum = this.sumPart()
        if (rowIndex % sum === 0) {
          return {
            rowspan: sum,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    // 隐藏掉不需要的表头
    discountHeaderStyle({ rowIndex }) {
      if (rowIndex == 1) {
        return { display: 'none' }
      } else {
        return 'background:rgba(55, 169, 231, 0.05);border-radius: 8px;border:none;'
      }
    },

    preload() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        Preload()
        try {
          // Preload index文件
          const url = this.rootPath + 'index.json'
          const indexFile = await this.preloadIndexFile(url)
          // 从index文件中获取文件列表
          const fileList = this.getIndexFileList(indexFile)
          console.log('fileList', fileList)
          // Preload 文件列表
          const files = await this.preloadFileList(fileList)
          console.log('files', files)
          // // 从文件列表中获取音频数组
          const audioList = this.getAudioList(files)
          console.log('audioList', audioList)
          // // Preload 音频数组
          await this.preloadAudios(audioList)
          // 所有文件预加载完成，可以进行后续操作
          resolve()
          Preload.setProgress(0)
          Preload.close()
        } catch (error) {
          console.log('error', error)
          reject()
          Preload.setProgress(0)
          Preload.close()
        }
      })
    },
    getIndexFileList(list) {
      let quesList = []
      list?.map((item) => {
        if (item.segment_code == 'listen') {
          //if (item.segment_code == 'speaking') {
          quesList.push({
            id: item.topic_items,
            src: this.rootPath + item.topic_items,
          })
        } else if (item.segment_code == 'speaking') {
          quesList.push({
            id: item.topic_items,
            src: this.rootPath + item.topic_items,
          })
        }
      })
      return quesList
    },
    getAudioList(fileList) {
      const zipParams = '?format=mp3&bitrate=64k'
      let list = []
      list = [
        // { id: 'testmp3', src: this.testmp3 },
        { id: this.explainAudio, src: this.explainAudio + zipParams },
      ]
      fileList.forEach((item) => {
        item.map((itm) => {
          // todo 优化成语林查询返回，或者定义类型映射关系，否则不利于拓展，紧急上线后面优化逻辑判断
          // 套题中有的题干里也有音频
          if (itm.questions && itm.listen) {
            list.push({
              id: itm.listen?.audio_file,
              src: this.rootPath + itm.listen?.audio_file + zipParams,
            })
            itm.questions.forEach((q) => {
              if (q.content || q?.listen?.type == 'audio' || q?.listen?.audio_file) {
                list.push({
                  id: q.content || q?.listen?.audio_file || q?.listen?.audio_file,
                  src:
                    this.rootPath +
                    (q.content || q?.listen?.audio_file || q?.listen?.audio_file) +
                    zipParams,
                })
              }
            })
          } else if (itm.questions) {
            // 套题类型
            itm.questions.forEach((q) => {
              if (q.content || q?.listen?.type == 'audio' || q?.listen?.audio_file) {
                list.push({
                  id: q.content || q?.listen?.audio_file || q?.listen?.audio_file,
                  src:
                    this.rootPath +
                    (q.content || q?.listen?.audio_file || q?.listen?.audio_file) +
                    zipParams,
                })
              }
            })
          } else {
            // 非套题类型
            if (itm.content || itm?.listen?.type == 'audio') {
              list.push({
                id: itm.content || itm?.listen?.audio_file,
                src: this.rootPath + (itm.content || itm?.listen?.audio_file) + zipParams,
              })
            }
          }
        })
      })
      console.log('项数', list)
      return list
    },
    // 预加载index文件
    preloadIndexFile(url) {
      return new Promise((resolve, reject) => {
        if (!url) return resolve()
        this.queue = new createjs.LoadQueue()
        this.queue.setMaxConnections(10)
        this.queue.on('complete', () => {
          const indexFile = this.queue.getResult(url)
          resolve(indexFile?.items)
        })
        this.queue.on('error', (event) => {
          reject(event)
        })
        this.queue.loadFile(url)
      })
    },
    // 预加载文件列表
    preloadFileList(fileList) {
      return new Promise((resolve, reject) => {
        this.queue.on('complete', () => {
          const files = []
          fileList.forEach((file) => {
            const fileData = this.queue.getResult(file.id)
            files.push(fileData?.items)
          })
          resolve(files)
        })
        this.queue.on('error', (event) => {
          reject(event)
        })
        this.queue.loadManifest(fileList)
      })
    },
    // 预加载音频数组
    preloadAudios(audioList) {
      return new Promise((resolve, reject) => {
        this.totalFiles += audioList.length
        // const queue = new createjs.LoadQueue();
        this.queue.on('progress', () => {
          this.loadedFiles += audioList.length
          this.updateProgressBar()
        })
        this.queue.on('complete', () => {
          resolve()
        })
        this.queue.on('error', (event) => {
          reject(event)
        })
        this.queue.loadManifest(audioList)
      })
    },
    // 更新进度条
    updateProgressBar() {
      const progress = Math.floor(this.queue.progress * 100)
      Preload.setProgress(progress)
      if (progress === 100) {
        Preload.setProgress(0)
        Preload.close()
      }
    },
    // 开始考试扣费
    async checkPay() {
      this.dialogPayCheck = false
      let mixpanelParams = {
        paper_type: this.filterPaperName(this.titleTrans),
        exam_type: this.levelName,
        type: 'buy',
      }
      analytics.logEvent('hskweb_start2_click', mixpanelParams)
      if (IS_CHINA) {
        this.$router.push({
          path: '/pay/index',
          query: { ...this.$route.query, product_id: this.productId, root_path: this.rootPath },
        })
        return
      } else {
        const { payment_link, order_id } = await this.getPayLink(this.productId)
        window.open(payment_link)
        this.dialogPayCb = true
        await this.createSetInterval(order_id)
      }
      this.confirm(0)
    },
    async startExam(type) {
      // 继续考试
      if (type === 2) {
        let mixpanelParams = {
          paper_type: this.filterPaperName(this.titleTrans),
          exam_type: this.levelName,
        }
        analytics.logEvent('hskweb_restart_click', mixpanelParams)
      } else {
        let mixpanelParams = {
          people_id: this.peopleId,
          unlimited: this.unlimited,
          paper_type: this.filterPaperName(this.titleTrans),
          exam_type: this.levelName,
          type: 'start',
        }
        analytics.logEvent('hskweb_start2_click', mixpanelParams)
      }
      if (this.$route.query.status == 3) {
        // 取消所有自动跳过试音功能
        // this.jumpTestPage()
      } else {
        if (!this.isFree) {
          // 重新开始
          // 检查是否有库存
          const { enough, product_id } = await this.searchAccountCredit()
          this.productId = product_id
          if (!enough) {
            this.dialogPayCheck = true
            return
          }
        }
        this.confirm(0)
      }
    },

    // 确认后执行的操作
    async confirm(status) {
      await this.preload()
      //start2埋点
      if (status == 1) {
        let mixpanelParams = {
          people_id: this.peopleId,
          unlimited: this.unlimited,
          paper_type: this.filterPaperName(this.titleTrans),
          exam_type: this.levelName,
          type: 'continue',
        }
        analytics.logEvent('hskweb_start2_click', mixpanelParams)
      }
      this.ansStatus = status
      // this.dialogPayVisible = false;
      this.dialogReadyVisible = true
    },
    jumpTestPage() {
      console.log(this.levelId, 'this.level')
      let finalLevel = this.levelId ? this.levelId : this.paperLevelId
      let { query } = this.$route
      let pageName = 'Simulation'
      if (finalLevel == 12) {
        pageName = 'SimulationHigh'
      }
      let hskklevelList = [8, 13, 14]
      if (hskklevelList.includes(finalLevel)) {
        pageName = 'SimulationHskk'
      }
      this.$router.replace({
        name: pageName,
        query: {
          ...query,
          ansStatus: this.ansStatus, // 0 重新 1 继续
          level: this.level,
        },
      })
    },

    // 跳过试音
    skip() {
      let mixpanelParams = {
        paper_type: this.filterPaperName(this.titleTrans),
        exam_type: this.levelName,
      }
      analytics.logEvent('hskweb_preparationskip_click', mixpanelParams)
      this.dialogReadyVisible = false

      this.jumpTestPage()
    },
    // 获取试卷每个题型的以及时间
    getPaperDetails() {
      utilV2.postData(
        ApiPath.hsk_paper_repare,
        {
          paperId: this.$route.query.paperId,
          examinationType: this.$route.query.examinationType, //hsk作业
        },
        (data) => {
          this.paperLevelId = data.levelId
          data.segments.forEach((segments) => {
            segments.parts.forEach((part) => {
              this.tableData.push({
                partCode: this.$t('hsk_part1', {
                  part:
                    localStorage.getItem('language') == 'zh'
                      ? numberToChinese(part.partCode)
                      : part.partCode,
                }),
                questionCount: part.questionCount,
                duration: `${
                  segments.segmentCode == 'listen' || segments.segmentCode == 'speaking'
                    ? this.$t('hsk_about')
                    : ''
                }${segments.duration}${this.$t('hsk_test_minute')}`,
                questionCountMoudleTotal: segments.questionCount,
                segmentCode: this.findSegmentCodeStr(segments.segmentCode),
                segmentCodePart: segments.segmentCode,
                totalDuration: `${segments.segmentCode == 'listen' ? this.$t('hsk_about') : ''}${
                  data.totalDuration
                }${this.$t('hsk_test_minute')}`,
                totalQuestionCount: `${data.totalQuestionCount}`,
                segmentDesc: this.level == 'hskk1' || this.level == 'hskk2' || this.level == 'hskk3' ? part.part_name : transferLanguage(segments.segmentDesc),
                objectiveQuestionCount: part.objectiveQuestionCount || null,
                subjectiveQuestionCount: part.subjectiveQuestionCount || null,
              })
            })
          })
          this.segments = data.segments
          this.testmp3 = this.level == 'hskk1' || this.level == 'hskk2' || this.level == 'hskk3' ? data.explainAudio : data.levelExplainAudio
          this.explainAudio = data.explainAudio
          this.listenReviewDuration = data.listenReviewDuration
          // console.log(JSON.stringify(this.tableData));
          this.titleTrans = JSON.parse(data.titleTrans)
          this.levelName = data.levelName
          let mixpanelParams = {
            paper_type: this.filterPaperName(this.titleTrans),
            people_id: this.peopleId,
            unlimited: this.unlimited,
            exam_type: data.levelName,
          }
          analytics.logEvent('hskweb_papercontent_view', mixpanelParams)
          this.rootPath = data.resource_url.slice(0, -4) + '/'
        }
      )
    },
    filterPaperName(nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return nameTrans[language]
    },
    // 判断一共有多少个部分
    sumPart() {
      let i = 0
      this.segments.forEach((seg) => {
        seg.parts.forEach(() => {
          i++
        })
      })
      return i
    },
    getSpan(list) {
      const newArr = []
      const obj = {}
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          obj.row = 1
          obj.col = 1
          newArr.push(obj)
        } else {
          if (list[i].segmentCode === list[i - 1].segmentCode) {
            newArr.push({ row: 0, col: 0 })
            const index = list.findIndex((item) => {
              return item.segmentCode === list[i - 1].segmentCode
            })
            newArr[index].row++
          } else {
            newArr.push({ row: 1, col: 1 })
          }
        }
      }
      return newArr
    },
    //根据segment_code返回多语言
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break
        case 'translation':
          codeStr = this.$t('Traduction')
          break
        case 'speaking':
          codeStr = this.$t('speaking')
          break
        default:
          break
      }
      return codeStr
    },
    // 充值弹框
    // rechargeMethod() {
    //   this.dialogRecharge = true;
    // },
    // 关闭充值弹框
    // closeCallback() {
    //   this.dialogRecharge = false;
    // },
    // 查询当前账户余额是否充足
    searchAccountCredit() {
      let params = {
        paper_id: this.$route.query.paperId,
      }
      if (this.$route.query.assignment_id) {
        params.assignment_id = this.$route.query.assignment_id
      }
      return new Promise((resolve) => {
        utilV2.getData(
          ApiPath.hsk_check_Credit,
          params,
          (data) => {
            resolve(data)
          },
          () => {},
          {
            showLoading: true,
          }
        )
      })
    },
    //获取订单id 并弹框
    // getOrderId(id, num) {
    //   //pay1埋点
    //   this.payNum = num;
    //   analytics.logEvent("hskweb_pay1_click", { url: window.location.href });
    //   this.orderId = id;
    //   this.dialogPayCb = true;
    //   this.isPaySuccess = false; // 初始化支付状态
    //   this.createSetInterval();
    // },
    // 支付取消
    // payCancel() {
    //   this.dialogPayCb = false;
    //   // this.dialogRecharge = false;
    //   this.dialogPayVisible = false;
    // },
    // // 支付完成
    // payFinished() {
    //   this.dialogPayCb = false;
    // },
    createSetInterval(orderId) {
      return new Promise((resolve) => {
        let _this = this
        clearInterval(_this.searchResultObj)
        this.searchResultObj = setInterval(() => {
          utilV2.getData(
            ApiPath.pay_recharge_log,
            { order_id: orderId },
            (data) => {
              //支付埋点
              if (data.status) {
                // _this.searchAccountCredit();
                // _this.dialogPayCb = false;
                // this.dialogRecharge = false;
                // _this.dialogPayVisible = false;
                _this.isPaySuccess = true
                _this.dialogPayCb = false
                resolve('success')
                clearInterval(_this.searchResultObj)
              }
            },
            () => {},
            {
              showLoading: false,
            }
          )
        }, 1000)
      })
    },
    // 检查余额
    inspectBalance() {
      this.$message({ type: 'error', message: this.$t('has_no_resolve_credit') })
      this.dialogPayCb = false
    },
    // 获取试卷支付连接
    getPayLink(product_id) {
      return new Promise((resolve, reject) => {
        apiRequest
          .post(
            window.ApiPath.stripe_create_order,
            {
              product_id: +product_id,
            },
            {
              loading: true,
            }
          )
          .then((res) => {
            resolve(res?.data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    linkPay() {
      //hskweb_payagain_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.levelName,
        paper_type: this.filterPaperName(this.titleTrans),
      }
      analytics.logEvent('hskweb_payagain_click', mixpanelParams)
      window.open(this.payLink)
    },
    contactUs() {
      //hskweb_paycontact_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.levelName,
        paper_type: this.filterPaperName(this.titleTrans),
      }
      analytics.logEvent('hskweb_paycontact_click', mixpanelParams)
      this.$router.push('/feedback')
    },
    closePay() {
      //hskweb_payclose_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.levelName,
        paper_type: this.filterPaperName(this.titleTrans),
      }
      analytics.logEvent('hskweb_payclose_click', mixpanelParams)
    },
  },
  destroyed() {
    Preload.setProgress(0)
    Preload.close()
    this.queue && this.queue.destroy()

    clearInterval(this.searchResultObj)
  },
}
</script>

<style lang="scss" scoped>
.page-main {
  .intro {
    &_top {
      height: 164px;
      background-image: url(~@/assets/images/introduce_header_bg.png);
      background-size: 100% 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 105px;
        height: 132px;
        margin: 21px 25px 11px 55px;
      }
      &-title {
        font-size: 20px;
        font-family: PingFangSC-Semibold, Inter;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
      }
    }
    &_table {
      margin: 30px 136px 30px 137px;
    }
    &-msg {
      li {
        display: flex;
        color: #696974;
        font-size: 14px;
        margin: 15px 0;
        &::before {
          margin: 6px 10px 0px 0;
          display: inline-block;
          content: '';
          height: 4px;
          width: 4px;
          border-radius: 100%;
          background-color: #696974;
        }
      }
    }
  }
  ::v-deep .el-table {
    border: none;
    &::before {
      height: 0;
    }
    &::after {
      height: 0;
    }
  }
  ::v-deep .el-table .el-table__body-wrapper .el-table__body {
    border-collapse: separate;
    border-spacing: 5px;
    table-layout: auto !important;
  }
  ::v-deep .el-table th.el-table__cell > .cell {
    word-break: break-word;
  }
  ::v-deep .el-table .el-table__header-wrapper .el-table__header,
  ::v-deep .el-table .el-table__footer-wrapper .el-table__footer {
    border-collapse: separate;
    border-spacing: 5px;
    table-layout: auto !important;
  }

  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(55, 169, 231, 0.1) !important;
  }

  .toolbar {
    margin-bottom: 34px;
  }
  .btn-tips {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #393d46;
    line-height: 30px;
    margin-top: 9px;
  }
  .btn-extend {
    width: 294px;
    height: 44px;
    border-radius: 6px;
    border: none;
    font-size: 18px;
    font-weight: 500;
    margin: 20px 30px 0 30px;
  }
  .btn-submit {
    width: 294px;
    height: 44px;
    border-radius: 6px;
    font-size: 18px;
  }
  .btn-exam {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    font-size: 18px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-exam-out {
    @extend .btn-exam;
    margin-top: 24px;
  }
  .btn-blue {
    background: #3bb590;
  }
  ::v-deep .el-dialog__body {
    font-size: 16px;
    font-weight: 500;
    color: rgba(43, 48, 57, 1);
    line-height: 24px;
    text-align: center;
    .wave {
      height: 98px;
      width: 100%;
      text-align: center;
      em {
        display: inline-block;
        vertical-align: middle;
        width: 2px;
        // max-height: 38px;
        margin: 0 2px;
        background: #faae56;
      }
    }
    .dialog_title {
      margin-top: 64px;
      font-size: 36px;
      font-family: PingFangSC-Semibold, Inter;
      font-weight: 600;
      color: rgba(57, 61, 70, 1);
      line-height: 36px;
      margin-bottom: 30px;
    }
    .dialog_tips {
      font-size: 16px;
      font-family: PingFangSC-Regular, Inter;
      font-weight: 400;
      color: rgba(134, 141, 153, 1);
      line-height: 25px;
      margin-bottom: 50px;
      word-break: break-word;
    }
    .pay-title {
      font-weight: 600;
      font-size: 17px;
      line-height: 24px;
      margin-top: 18px;
    }
    .diamond {
      display: flex;
      align-items: center;
      margin-top: 12px;
      min-width: 57px;
      height: 22px;
      border-radius: 4px;
      font-size: 14px;
      color: #696974;
      .numbers {
        color: #1187c9;
      }
    }
    .balance {
      display: flex;
      align-items: center;
      margin-top: 8px;
      color: #696974;
      font-weight: 400;
      font-size: 14px;
      .Recharge {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }
    .key_desc {
      min-width: 160px;
      text-align: right;
    }
  }
  ::v-deep .el-dialog {
    border-radius: 12px;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-table tbody tr:hover > td {
    background-color: #ffffff !important;
  }
  ::v-deep .el-table td.el-table__cell div {
    word-break: break-word;
  }
  ::v-deep .el-collapse {
    border: none;
    margin-top: 37px;
    .el-collapse-item__header {
      border: none;
      justify-content: center;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #2c2f46;
      .el-collapse-item__arrow {
        margin: 0 0 0 10px;
      }
    }
    .el-collapse-item__wrap {
      border: none;
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #f2f3f5;
    span {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 59px;
      cursor: pointer;
      &:first-child {
        border-right: 1px solid #f2f3f5;
      }
    }
  }
  button[disabled] {
    cursor: not-allowed;
    background: #dcdde3;
  }
  ::v-deep .recharge-body {
    .el-dialog__header {
      padding: 20px 20px 0 !important;
      text-align: left;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      color: #2c2f46;
    }
    .el-dialog__body {
      padding: 16px;
    }
  }
  ::v-deep .hsk_skip {
    .el-dialog__header {
      border-bottom: 1px solid #e9e9e9;
      padding: 20px 20px 10px;
      .el-dialog__title {
        color: #2c2f46;
        font-size: 18px;
        font-weight: 700;
      }
    }
    .el-dialog {
      border-radius: 0px;
    }
    .el-dialog__body {
      padding: 30px 50px 24px;
      text-align: left;
    }
  }
  ::v-deep .paper-intro {
    .el-dialog__header {
      padding-top: 29px;
      .el-dialog__title {
        color: #2c2f46;
        font-size: 30px;
        font-weight: 700;
      }
    }
    .el-dialog__body {
      padding: 38px 50px 24px 66px;
    }
    .paper-intro-wrap {
      li {
        margin-bottom: 20px;
        text-align: left;
        display: flex;
        img {
          width: 24px;
          height: 24px;
          padding: 3px;
          margin-right: 10px;
        }
        span {
          color: #696974;
          font-size: 16px;
        }
      }
      .questions-wrap {
        color: #696974;
        text-align: center;
        font-size: 14px;
        b {
          font-weight: 700;
          cursor: pointer;
        }
      }
      .close-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 360px;
        margin: 53px auto 20px;
        padding: 10px 24px;
      }
    }
  }
  ::v-deep .pay-body {
    .el-dialog__body {
      padding: 16px;
      img {
        margin-top: 52px;
        animation: toRotate 1s linear infinite;
      }
      .pay-tips {
        color: #2c2f46;
        font-weight: 600;
        font-size: 16px;
        margin-top: 24px;
      }
      .button-tools {
        display: flex;
        justify-content: space-between;
        margin-top: 49px;
        .btm-pay {
          width: 192px;
          height: 44px;
          border-radius: 4px;
        }
      }
    }
    .pay-success {
      margin-top: 70px;
      .success-bg {
        width: 60px;
        height: 60px;
        background: #3bb590;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
      }
    }
    .un_pay_tips {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 30px;
      p {
        cursor: pointer;
        margin-left: 5px;
        text-decoration: underline;
        color: #faae56;
      }
      .contact-us {
        color: #9141c7;
      }
    }
    @keyframes toRotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
  }
}
.pay-header {
  padding: 25px 24px;
  color: #000;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-bottom: 1px solid #e5e5e5;
}
.pay-text {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 15px;
  margin-bottom: 45px;
}
.use-code {
  width: 254px;
  border-radius: 4px;
  border: 0.5px solid var(--Wohui-Grey-3, #b5b5be);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), #fff;
}
.use-buy {
  width: 254px;
  margin-left: 30px;
}
.segment-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  .segment_img {
    width: 28px;
    height: 28px;
    margin-right: 5px;
  }
  .segment_img_listen {
    width: 38px;
    height: 38px;
    margin-right: 0px;
  }
  .segment-cell-text {
    display: flex;
    align-items: center;
  }
}
</style>
